import DaisyController from '../../daisy/daisy.controller';

/**
 * this is the global transfer order module as a wrapper for all small modules inside of it
 * the controller provide some common functions to call from inside the child classes
 **/
export default class TransferOrderController extends DaisyController {
	/**
	 * define required services here
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		super($injector);
		this.TransferOrderStateService = $injector.get('TransferOrderStateService');

		this.dangerOffsetTime = 30;
		this.warningOffsetTime = 30;
		this.checkDelayedOrderIntervalTime = (60 * 1) * 1000; // ToDo: Use 5 Minutes in Production
	}

	$onInit() {

	}

	$onDestroy() {
		
	}
}
